import './App.css';
import Header from "./header";
import Body1 from "./body1"
import Body2 from "./body2"
import Body3 from "./body3"

function App() {
  return (
    <div className='app'>
      <Header />
      <Body1 />
      <Body2 />
      <Body3 />
    </div>
  );
}

export default App;
